/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingItemDto } from './buildingItemDto';
import { InspectionPermissions } from './inspectionPermissions';
import { ConditionDto } from './conditionDto';
import { TenantItemDto } from './tenantItemDto';
import { UserItemDto } from './userItemDto';


export interface InspectionItemDto { 
    id: string;
    name: string;
    continuationNumber: number;
    status: InspectionItemDto.StatusEnum;
    fromTimestamp: string;
    toTimestamp: string;
    version: number;
    building: BuildingItemDto;
    technician: UserItemDto;
    ownerTenant: TenantItemDto;
    clerk?: UserItemDto;
    condition: ConditionDto;
    normType: InspectionItemDto.NormTypeEnum;
    inspectionType: InspectionItemDto.InspectionTypeEnum;
    usedTemplateId?: string;
    permissions: InspectionPermissions;
    sendingTimestamp?: string;
    creatorTenant: TenantItemDto;
}
export namespace InspectionItemDto {
    export type StatusEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'IN_REVIEW' | 'DONE' | 'SENT' | 'NONE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Todo: 'TODO' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        InReview: 'IN_REVIEW' as StatusEnum,
        Done: 'DONE' as StatusEnum,
        Sent: 'SENT' as StatusEnum,
        None: 'NONE' as StatusEnum
    };
    export type NormTypeEnum = 'NORM_1300' | 'NORM_1301';
    export const NormTypeEnum = {
        Norm1300: 'NORM_1300' as NormTypeEnum,
        Norm1301: 'NORM_1301' as NormTypeEnum
    };
    export type InspectionTypeEnum = 'REGULAR' | 'SCHADSTELLENPLAN';
    export const InspectionTypeEnum = {
        Regular: 'REGULAR' as InspectionTypeEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as InspectionTypeEnum
    };
}


